import React from "react";
import Footer from "../components/footer";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLanguage } from "../components/idiomas";

export default function HomePage() {
  const { language, translations } = useLanguage();
  const t = translations[language].home;

  return (
    <div className="min-h-screen flex flex-col font-sans bg-gradient-to-b from-[#1E2E45]/10 to-white text-[#1E2E45]">

      {/* Sección principal */}
      <motion.header
        className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center px-8 md:px-16 py-16"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="space-y-5">
          <span className="inline-block px-3 py-1 bg-[#1E2E45]/10 text-[#1E2E45] rounded-full text-sm">
            {t.trust}
          </span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1E2E45] leading-tight">
            {t.mainTitle}
          </h1>
          <p className="text-[#1E2E45]/80 text-lg">{t.description}</p>
        </div>

        <motion.aside
          className="mx-auto w-fit"
          initial={{ opacity: 0, x: 90 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img
            src="/images/imageninicio.png"
            alt={language === "es" ? "Imagen de inicio" : "Home illustration"}
            className="w-full max-w-md rounded-lg"
          />
        </motion.aside>
      </motion.header>

      {/* --- SECCIÓN DE CASOS --- */}
      <motion.section
        className="px-8 md:px-16 py-20 bg-white"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-center text-3xl md:text-3xl font-bold mb-12">
          {t.sectionTitle}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Lista de casos */}
          <div className="space-y-6">
            {t.cases.map((text, i) => (
              <div key={i} className="flex items-start space-x-3">
                <FaCheckCircle className="text-[#1E2E45] text-xl mt-1" />
                <p className="text-[#1E2E45]/90 leading-relaxed">{text}</p>
              </div>
            ))}

            <Link to="/contact">
              <button className="mt-6 bg-[#1E2E45] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#162339] transition">
                {t.contactBtn}
              </button>
            </Link>
          </div>

          {/* Imágenes */}
          <div className="grid grid-cols-2 grid-rows-2 gap-4">
            <img
              src="/images/carroinicio.png"
              alt={t.images.carro}
              className="rounded-lg shadow-md object-cover w-full h-48"
            />
            <img
              src="/images/doctorinicio.png"
              alt={t.images.doctor}
              className="rounded-lg shadow-md object-cover w-full h-48"
            />
            <img
              src="/images/caidainicio.png"
              alt={t.images.caida}
              className="rounded-lg shadow-md object-cover w-full h-48"
            />
            <img
              src="/images/familiainicio.png"
              alt={t.images.familia}
              className="rounded-lg shadow-md object-cover w-full h-48"
            />
          </div>
        </div>
      </motion.section>

      {/* --- NUEVA SECCIÓN: BUFETES ALIADOS (Diseño minimalista con logos grandes) --- */}
        <motion.section
          className="px-8 md:px-16 py-24 bg-gradient-to-t"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E2E45] mb-3">
              {t.bufetesTitle}
            </h2>
            <p className="text-[#1E2E45]/70 text-lg max-w-2xl mx-auto">
              {t.bufetesDescription}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Bufete 1 */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="flex items-center justify-center  transition h-64"
            >
              <img
                src="/images/sotoabogados.png"
                alt="Soto & Asociados"
                className="w-64 md:w-72 object-contain"
              />
            </motion.div>

            {/* Bufete 2 */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="flex items-center justify-center transition h-64"
            >
              <img
                src="/images/buleeabogados.png"
                alt="Bulee & Asociados"
                className="w-64 md:w-72 object-contain"
              />
            </motion.div>
          </div>
        </motion.section>


      <Footer />
    </div>
  );
}
